import { gql } from '@apollo/client';

export const GET_LINE_ITEMS_FOR_EXPORT = gql`
  query GET_LINE_ITEMS_FOR_EXPORT(
    $filterOptions: LineItemFilterOptionsV5
    $sort: LineItemSortOptionV5
    $order: OrderOption
    $limit: Int
    $offset: Int
  ) {
    lineItems: lineItemsV5(
      filterOptions: $filterOptions
      sortOptions: { sort: $sort, order: $order }
      paginationOptions: { limit: $limit, offset: $offset }
    ) {
      edges {
        node {
          __typename
          id
          pacingMetrics {
            yodaPacingStatus
            generalPacingStatus
            yodaThreshold
          }
          pacingType
          trackingId
          brandCapping
          name
          tier {
            name
            rank
          }
          priority {
            name
            rank
          }
          review
          status
          subStatus
          parentLineOmsLink {
            id
          }
          lineOmsLink {
            id
            type
          }
          adProduct
          billableThirdParty
          unitCost
          unitCostDto {
            currency
            micros
          }
          costMethod
          secondRoundEligible
          dhxpBackfill
          creativeMaxSeconds
          exclusiveBlock {
            id
            name
            lineItemIdList
          }
          draxDeal {
            packageId
            packageName
            dealId
            dealName
            dspId
          }
          campaign {
            id
            name
            traffickerEmail
            order {
              salespersonEmail
              billingCalendar
            }
            adAccount {
              id
              timezone
              organizationId
            }
            campaignTagList {
              id
              type
              url
            }
            crmLink {
              id
              name
            }
            startDate
          }
          lineItemSequenceId
          revenue
          priorityValue
          schedule {
            timezone
            dateRangeList {
              startDate
              endDate
              pacingShare
            }
            dayPartList {
              firstActiveHour
              lastActiveHour
              activeDayList
            }
            deliveryInViewerTime
          }
          frequencyCapList {
            type
            limit
            duration
            durationUnit
            enabled
          }
          deliveryBufferPercent
          frontLoadPercent
          preemptible
          goal
          isFiller
          podBuyout
          industryExclusive
          metrics {
            percentExpected
            percentPacing
            scheduledPercentPacing
            percentCompletions
            remainingExpectedCompletionsAcc
            revenueAtRisk
            completions
            underPacingRevenue
            completionsAtRisk
            impressions
            adjustedDeliveryGoal
          }
          startDate
          endDate
          createdAt
          updatedAt
          hasZeroDeliveryRisk
          hasMisalignedSchedule
          deliveryGoal
          displayPublisherTarget
          isCoppaOrCaru
          isMakegood
          isAddedValue
          orderLineItemDto {
            parentLineOmsLink {
              id
              type
            }
            packageName
            childLineOmsLink {
              id
              type
            }
            isMakeGood
            buyerName
            buyerId
          }
          magniteDealDto {
            dealId
            dealName
            adSourceId
            adSourceName
            dspName
          }
          metadata {
            actualStartDate
          }
          maxCreativeMs
          country
          countries
          inventoryBlockId
          doNotTraffic
          brandCapping
          customPacingApplied
          cpEligible
          cpRequested
          ssp
          dealMetadata {
            dealId
            dspName
          }
          deal {
            __typename
            dealId
          }
          billableEvent
          distributionPartnerList
          automateBuffer
          automatedDeliveryBufferPercent
          staqError
          staqErrorExtended {
            date
            description
          }
        }
      }
      total
    }
  }
`;
